import React, { useEffect, useState } from 'react'
import { logoutUser } from '../store/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import { ClipboardDocumentIcon, LockClosedIcon, LockOpenIcon, XMarkIcon } from '@heroicons/react/24/solid';
import { closeCaisseRegister, getCaisseRegisterBalance, getCaisseRegisterStatus, openCaisseRegister, retraitCaisseRegister } from '../store/settingsSlice';
import { CaisseOuvertureForm, CaisseFermetureForm, CaisseRetraitForm } from '../config';
import ModalForm from './common/ModalForm';
import CommonForm from './common/CommonForm';


function Sidebar() {
    const { user, isAuthenticated } = useSelector((state) => state.auth);
    const { caisseBalance, caisseRegisterHistory, caisseStatus } = useSelector((state) => state.settings);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const [formControls, setFormControls] = useState(CaisseOuvertureForm);
    const [formTitle, setformTitle] = useState("Ajouter une categorie");
    const [TypeCaisse, setTypeCaisse] = useState("");

    const [isCaisseOpen, setIsCaisseOpen] = useState(false);

    const dispatch = useDispatch();

    const handleLogout = () => {
        dispatch(logoutUser());
    }
    const [formData, setFormData] = useState({});

    useEffect(() => {
        // Dispatch des actions une seule fois au montage
        dispatch(getCaisseRegisterBalance(user.id));
    }, [caisseBalance]);



    useEffect(() => {
        // Dispatch des actions une seule fois au montage
        dispatch(getCaisseRegisterStatus(user.id));
    }, [caisseStatus]);

    const getStatus = () => {
        // recupérer l'etat de la caisse dans le store        
        if (caisseStatus) {
            return true;
        } else {
            return false;
        }
    };

    useEffect(() => {
        handleClose();
    }, [formData]);



    function validateForm(TypeCaisse) {
        if (TypeCaisse === "ouverture") {
            if (parseFloat(formData.openingAmount) <= 0) return "Veuillez Saisir la désignation.";
        } else if (TypeCaisse === "fermeture") {
            if (parseFloat(formData.closingAmount) < parseFloat(caisseBalance)) {
                if (formData.discrepancyExplanation === "") return "Merci de fournir des explications sur la caisse non balancé.";
                if (formData.discrepancyAgentId === "") return "Merci de fournir votre nom et matricule.";
            }
        } else if (TypeCaisse === "ajout") {
            if (parseFloat(formData.amount) <= 0) return "Veuillez Saisir le montant à ajouter.";
        } else if (TypeCaisse === "retrait") {
            if (parseFloat(formData.openingAmount) <= 0) return "Veuillez Saisir la désignation.";
        }
        return null;
    };

    function handleClose() {
        if (TypeCaisse === "fermeture") {
            if (formData && parseFloat(formData.closingAmount) !== parseFloat(caisseBalance)) {
                document.getElementById("discrepancyExplanation").style.display = "block";
                document.getElementById("discrepancyAgentId").style.display = "block";
            } else {
                document.getElementById("discrepancyExplanation").style.display = "none";
                document.getElementById("discrepancyAgentId").style.display = "none";
            }
        }
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        console.log("TypeCaisse", TypeCaisse);

        const errorMessage = validateForm(TypeCaisse);
        if (errorMessage) {
            alert(errorMessage); // Remplacez par un meilleur système de gestion des erreurs
            return;
        }

        if (TypeCaisse === "ouverture" && getStatus() === false) {
            console.log("Ouverture caisse");

            dispatch(openCaisseRegister({ userId: user.id, formData: formData })).then((data) => {
                if (data?.payload?.success) {
                    dispatch(getCaisseRegisterBalance(user.id));
                    document.getElementById("sideBar").style.display = "none";
                    setIsCaisseOpen(false) // Ouvre la caisse
                    setFormData({});
                    setIsModalOpen(false);// Ferme le modal aprs la soumission
                }
            })
            setTypeCaisse("")
        } else if (TypeCaisse === "fermeture") {
            console.log("Fermeture caisse");
            console.log("formData", formData);
            dispatch(closeCaisseRegister({ userId: user.id, formData: formData })).then((data) => {
                if (data?.payload?.success) {
                    dispatch(getCaisseRegisterBalance(user.id));
                    document.getElementById("sideBar").style.display = "none";
                    setIsCaisseOpen(false) // Ouvre la caisse
                    setFormData({});
                    setIsModalOpen(false);// Ferme le modal aprs la soumission
                }
            })
            setTypeCaisse("")
        } else if (TypeCaisse === "retrait") {
            console.log("retrait caisse");
            console.log("formData", formData);
            dispatch(retraitCaisseRegister({ userId: user.id, formData: formData })).then((data) => {
                if (data?.payload?.success) {
                    dispatch(getCaisseRegisterBalance(user.id));
                    document.getElementById("sideBar").style.display = "none";
                    setIsCaisseOpen(false) // Ouvre la caisse
                    setFormData({});
                    setIsModalOpen(false);// Ferme le modal aprs la soumission
                }
            })
            setTypeCaisse("")
        }
    }




    function CaisseForme(TypeCaisse) {
        setTypeCaisse(TypeCaisse);
        if (TypeCaisse === "ouverture") {
            setFormControls(CaisseOuvertureForm);
            setformTitle("Ouverture de caisse");
            setIsModalOpen(true);
        } else if (TypeCaisse === "fermeture") {
            setFormControls(CaisseFermetureForm);
            setformTitle("Fermeture de caisse");
            setIsModalOpen(true);

        }else if (TypeCaisse === "retrait") {
            setFormControls(CaisseRetraitForm);
            setformTitle("Retrait de la caisse");
            setIsModalOpen(true);

        } else if (TypeCaisse === "ajout") {

        } 


    }

    function formatPrice(price) {
        return price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    return (
        <div id="sideBar" className="relative md:top-0 md:z-30 md:fixed flex flex-col flex-wrap flex-none border-gray-300 bg-white md:shadow-xl md:-ml-64 p-6 border-r w-44 md:h-screen animated faster">


            {/* sidebar content */}
            <div className="flex flex-col">

                {/* sidebar toggle */}
                <div className="md:block text-right hidden mb-4">
                    <button id="sideBarHideBtn">
                        <i className="fa-times-circle fad"></i>
                    </button>
                </div>
                {/* end sidebar toggle */}

                <p className="mb-4 text-gray-600 text-xs uppercase tracking-wider">Accueil</p>

                {/* link */}
                <a href="/" className="mb-3 font-medium text-sm hover:text-teal-600 capitalize transition duration-500 active ease-in-out">
                    <i className="mr-2 text-teal-400 text-xs fa-croissant fa-light fad"></i>
                    POS Sold
                </a>
                {/* end link */}

                {user.role === "admin" ?

                    <>
                        {/* link */}
                        <a href="/analyse" className="mb-3 font-medium text-sm hover:text-teal-600 capitalize transition duration-500 ease-in-out">
                            <i className="mr-2 text-teal-400 text-xs fa-chart-pie fad"></i>
                            Analyse
                        </a>
                        {/* end link */}

                        {/* link */}
                        <a href="/ventes" className="mb-3 font-medium text-sm hover:text-teal-600 capitalize transition duration-500 ease-in-out">
                            <i className="mr-2 text-teal-400 text-xs fa-shopping-cart fad"></i>
                            Ventes
                        </a>
                        {/* end link */}

                        <p className="mt-4 mb-4 text-gray-600 text-xs uppercase tracking-wider">Gestions</p>

                        {/* link */}
                        <a href="/product" className="mb-3 font-medium text-sm hover:text-teal-600 capitalize transition duration-500 ease-in-out">
                            <i className="mr-2 text-teal-400 text-xs fa-croissant fa-light fad"></i>
                            Produits
                        </a>
                        {/* end link */}

                        {/* link */}
                        <a href="/plats" className="mb-3 font-medium text-sm hover:text-teal-600 capitalize transition duration-500 ease-in-out">
                            <i className="mr-1 text-teal-400 text-xs fa-burger-soda fa-light fa-sharp fad" ></i>
                            Plats
                        </a>
                        {/* end link */}

                        {/* link */}
                        <a href="/reservation" className="mb-3 font-medium text-sm hover:text-teal-600 capitalize transition duration-500 ease-in-out">
                            <i className="mr-2 text-teal-400 text-xs fa-calendar-edit fad"></i>
                            Réservation
                        </a>
                        {/* end link */}

                        {/* link */}
                        <a href="/customer" className="mb-3 font-medium text-sm hover:text-teal-600 capitalize transition duration-500 ease-in-out">
                            <i className="mr-1 text-teal-400 text-xs fa-users fad"></i>
                            Clients
                        </a>
                        {/* end link */}

                        {/* link */}
                        <a href="/invoice" className="mb-3 font-medium text-sm hover:text-teal-600 capitalize transition duration-500 ease-in-out">
                            <i className="mr-2 text-teal-400 text-xs fa-file-invoice-dollar fad"></i>
                            Reçus
                        </a>
                        {/* end link */}
                        {/* link */}
                        <a href="/recus" className="mb-3 font-medium text-sm hover:text-teal-600 capitalize transition duration-500 ease-in-out">
                            <i className="mr-1 text-teal-400 text-xs fa-comment-alt-dots fad"></i>
                            Contacts
                        </a>
                        {/* end link */}

                        <p className="mt-4 mb-4 text-gray-600 text-xs uppercase tracking-wider">Configurations</p>

                        {/* link */}
                        <a href="/categorie" className="mb-3 font-medium text-sm hover:text-teal-600 capitalize transition duration-500 ease-in-out">
                            <i className="mr-2 text-teal-400 fa-light fa-list fa-sharp fad"></i>
                            Catégories
                        </a>
                        {/* end link */}

                        {/* link */}
                        <a href="/user" className="mb-3 font-medium text-sm hover:text-teal-600 capitalize transition duration-500 ease-in-out">
                            <i className="mr-1 text-teal-400 text-xs fa-users fad"></i>
                            Utilisateurs
                        </a>
                        {/* end link */}

                        {/* link */}
                        <a href="/fournisseur" className="mb-3 font-medium text-sm hover:text-teal-600 capitalize transition duration-500 ease-in-out">
                            <i className="mr-2 text-teal-400 text-xs fa-building fa-sharp fa-solid fad"></i>
                            Fournisseur
                        </a>
                        {/* end link */}

                        {/* link */}
                        <a href="/table" className="mb-3 font-medium text-sm hover:text-teal-600 capitalize transition duration-500 ease-in-out">
                            <i className="fa-border-all mr-2 text-teal-400 text-xs fa-duotone fad"></i>
                            Tables
                        </a>
                        {/* end link */}

                        {/* link */}
                        <a href="/setting" className="mb-3 font-medium text-sm hover:text-teal-600 capitalize transition duration-500 ease-in-out">
                            <i className="mr-2 text-teal-400 text-xs fa-bars fa-sharp fa-thin fad"></i>
                            Settings
                        </a>
                        {/* end link */}

                        {/* User configs */}
                        <p className="flex items-center gap-2 mt-4 mb-4 text-gray-600 text-xs uppercase tracking-wider">
                            <img className="w-6 h-6 object-cover" src="assets/img/user.svg" />
                            {user.username}
                        </p>
                        {/* Balance de la caisse */}
                        <p className='mb-4 text-gray-800 text-xs tracking-wider'>CAISSE: {formatPrice(caisseBalance || 0)}</p>
                        {/* end Balance de la caisse */}
                        {/* caisse */}
                        {getStatus() ? (
                            <a
                                onClick={() => {
                                    CaisseForme("fermeture")
                                }}
                                className="flex items-center mb-3 font-medium text-sm hover:text-teal-600 capitalize transition duration-500 cursor-pointer ease-in-out">
                                <LockOpenIcon className="mr-2 w-4 h-4 text-teal-400 text-xs" />
                                Ferme Caisse
                            </a>
                        ) : (
                            <a
                                onClick={() => {
                                    CaisseForme("ouverture")
                                }}
                                className="flex items-center mb-3 font-medium text-sm hover:text-teal-600 capitalize transition duration-500 cursor-pointer ease-in-out">
                                <LockClosedIcon className="mr-2 w-4 h-4 text-teal-400 text-xs" />
                                Ouvre Caisse
                            </a>
                        )}
                        {/* end caisse */}

                        {/* Retrait */}
                        <a className="flex items-center mb-3 font-medium text-sm hover:text-teal-400 capitalize transition duration-500 cursor-pointer ease-in-out"
                            onClick={() => {
                                CaisseForme("retrait")
                            }}>
                            <i className="mr-2 text-teal-400 text-xs fa-money-bill fa-sharp fa-solid fad"></i>
                            Retrait
                        </a>
                        {/* end retrait */}
                        {/* deconnect */}
                        <a className="flex items-center mb-3 font-medium text-sm hover:text-teal-400 capitalize transition duration-500 cursor-pointer ease-in-out"
                            onClick={handleLogout}>
                            <i className="mr-2 text-teal-400 text-xs fa-user-times fad"></i>
                            Déconnexion
                        </a>
                        {/* end deconnect */}

                    </>

                    :
                    <>
                        {/* User configs */}
                        <p className="flex items-center gap-2 mt-4 mb-4 text-gray-600 text-xs uppercase tracking-wider">
                            <img className="w-6 h-6 object-cover" src="assets/img/user.svg" />
                            {user.username}
                        </p>

                        {/* Balance de la caisse */}
                        <p className='mb-4 text-gray-800 text-xs tracking-wider'>CAISSE: {formatPrice(caisseBalance || 0)}</p>
                        {/* end Balance de la caisse */}
                        {/* caisse */}
                        {getStatus() ? (
                            <a
                                onClick={() => {
                                    CaisseForme("fermeture")
                                }}
                                className="flex items-center mb-3 font-medium text-sm hover:text-teal-600 capitalize transition duration-500 cursor-pointer ease-in-out">
                                <LockOpenIcon className="mr-2 w-4 h-4 text-teal-400 text-xs" />
                                Ferme Caisse
                            </a>
                        ) : (
                            <a
                                onClick={() => {
                                    CaisseForme("ouverture")
                                }}
                                className="flex items-center mb-3 font-medium text-sm hover:text-teal-600 capitalize transition duration-500 cursor-pointer ease-in-out">
                                <LockClosedIcon className="mr-2 w-4 h-4 text-teal-400 text-xs" />
                                Ouvre Caisse
                            </a>
                        )}
                        {/* end caisse */}

                        {/* deconnect */}
                        <a className="flex items-center mb-3 font-medium text-sm hover:text-teal-400 capitalize transition duration-500 cursor-pointer ease-in-out"
                            onClick={handleLogout}>
                            <i className="mr-2 text-teal-400 text-xs fa-user-times fad"></i>
                            Déconnexion
                        </a>
                        {/* end deconnect */}

                        {/* end User configs */}
                    </>
                }

            </div>
            {/* end sidebar content */}

            <ModalForm
                isOpen={isModalOpen}
                onClose={() => {
                    setIsModalOpen(false)
                }}
                children={
                    <CommonForm
                        formControls={formControls}
                        formData={formData}
                        formTitle={formTitle}
                        setFormData={setFormData}
                        handleSubmit={handleSubmit}
                        ButtonText="Soumettre"
                    />
                }
            />

        </div>
    )
}

export default Sidebar